"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _user = require("@/api/admin/user/user");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          name: [{
            required: true,
            message: "请输入管理员姓名",
            trigger: "blur"
          }, {
            min: 2,
            max: 12,
            message: "长度在 2 到 12 个字符",
            trigger: "blur"
          }],
          uniqueCode: [{
            required: true,
            message: "请输入编号",
            trigger: "blur"
          }],
          idCard: [
          // { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          loginName: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }],
          phoneNumber: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }],
          mail: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }],
          schoolId: [{
            required: true,
            message: "请输入所属学校",
            trigger: "blur"
          }]
        },
        labelWidth: "160px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          span: 12,
          type: "selectX",
          label: "所属学校：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入所属学校",
          prop: "schoolId",
          value: [],
          options: []
        }, {
          type: "input",
          label: "姓名：",
          isDisabled: false,
          placeholder: "请输入姓名",
          prop: "name",
          value: "",
          span: 12
        }, {
          span: 12,
          type: "input",
          label: "登录账号：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入登录账号",
          prop: "loginName",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "身份证号：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入身份证号",
          prop: "idCard",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "手机号：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入手机号",
          prop: "phoneNumber",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "邮箱：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入邮箱",
          prop: "mail",
          value: ""
        }, {
          type: "radio",
          label: "设为默认管理员：",
          isDisabled: false,
          prop: "isSys",
          value: "1",
          span: 12,
          options: [{
            name: "是",
            value: "1",
            isDisabled: true
          }, {
            name: "否",
            value: "2",
            isDisabled: false
          }]
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      console.log(e);
      (0, _user.provinceAdd)(e).then(function (res) {
        _this.$message.success("操作成功。");
        _this.$router.push("/province/provinceList");
      }).catch(function (e) {
        return e;
      });
    }
  }
};